import { InfoWindow, Marker } from "@vis.gl/react-google-maps";
import { useState } from "react";

import { NextProperty } from "legacyNext/types";

import { S } from "./asset-marker.styles";
import { AssetMarketContent } from "./AssetMarketContent";

type Props = {
    asset: NextProperty;
};

export const AssetMarker = (props: Props) => {
    const { asset } = props;
    const [selectedMarker, setSelectedMarker] = useState<NextProperty | null>(
        null
    );

    const location = {
        lat: asset.latitude,
        lng: asset.longitude,
    };

    return (
        <>
            <Marker
                key={asset.id}
                position={location}
                onClick={() => setSelectedMarker(asset)}
            />

            {selectedMarker && (
                <InfoWindow
                    position={location}
                    onCloseClick={() => setSelectedMarker(null)}
                >
                    <S.AssetType>
                        {asset.objectType[0].toUpperCase()}
                    </S.AssetType>

                    <AssetMarketContent asset={selectedMarker} />
                </InfoWindow>
            )}
        </>
    );
};
